import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { AppHeaderService } from 'src/app/services/app-header/app-header.service';
import { UserService } from 'src/app/services/user/user.service';
import { ProfileService } from 'src/app/services/profile/profile.service';
import { FeatureSwitchService } from 'src/app/services/feature-switch/feature-switch.service';

@Component({
    selector: 'app-icon-rail',
    templateUrl: './icon-rail.component.html',
    styleUrls: ['./icon-rail.component.scss'],
    standalone: false,
})
export class IconRailComponent {
  showProfilePopover = false;

  constructor(
    public appHeader: AppHeaderService,
    public featureSwitch: FeatureSwitchService,
    public profile: ProfileService,
    public user: UserService,
    private router: Router,
  ) {}

  navigate(page: string): void {
    this.appHeader.navigateToPage(page);
  }

  isActive(tab: string): boolean {
    return this.appHeader.activeTab === tab;
  }

  toggleProfilePopover(): void {
    this.showProfilePopover = !this.showProfilePopover;
  }

  logout(): void {
    this.showProfilePopover = false;
    this.user.logout();
  }
}
